"use client";

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import Title from "../../components/title";
import GoogleIcon from "../../components/svg/google-icon"; 
import StarRating from "../../components/svg/stars"; 
import {getStrapiURL} from "../../../helper/image-helper";

interface GoogleReviewsProps {
    title: string; 
    review: Array<{
        fullName: string;
        text: string;
        date: string;
        image: {
            url: string;
        };
    }>;
}

const GoogleReviews: React.FC<GoogleReviewsProps> = ({ title, review }) =>  {
    return (
        <div className="w-full pt-[48px]">
            <div className="flex justify-between items-center mb-[67px] max-[576px]:mb-[28px]">
                <Title
                    text={title}
                    position="center"
                    color="text-white"
                />
                <div className="flex space-x-3 max-[576px]:hidden">
                    <button
                        className="review-button-prev flex justify-center items-center w-[56px] h-[56px] px-4 rounded-full border-[2px] shadow-[0_8px_16px_0_#353C7880] border-violet-50 bg-white hover:bg-violet-50"
                        aria-label="Previous slide"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15.75 19.5L8.25 12l7.5-7.5"
                            />
                        </svg>
                    </button>
                    <button
                        className="review-button-next flex justify-center items-center w-[56px] h-[56px] px-4 rounded-full border-[2px] shadow-[0_8px_16px_0_#353C7880] border-violet-50 bg-white hover:bg-violet-50"
                        aria-label="Next slide"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M8.25 4.5l7.5 7.5-7.5 7.5"
                            />
                        </svg>
                    </button>
                </div>
            </div>

            {/* Обертка для Swiper и мобильных кнопок */}
            <div className="relative">
                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        nextEl: ".review-button-next",
                        prevEl: ".review-button-prev",
                    }}
                    spaceBetween={24}
                    slidesPerView={4}
                    breakpoints={{
                        320: { 
                            slidesPerView: 1,
                            spaceBetween: 16,
                        },
                        640: { 
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        },
                        1280: { 
                            slidesPerView: 4,
                            spaceBetween: 24,
                        },
                    }}
                    className="w-full"
                >
                    {review.map((item, index) => (
                        <SwiperSlide key={index}>
                            <div className="p-6 bg-white rounded-3xl shadow-md flex flex-col min-h-[248px] max-[576px]:min-h-[216px]">
                                <div className="flex justify-between items-start">
                                    <div className="flex items-center space-x-4">
                                        <img
                                            src={getStrapiURL(item.image.url)}
                                            alt={item.fullName}
                                            className="w-[40px] h-[40px] rounded-full object-cover max-[576px]:w-[32px] max-[576px]:h-[32px]"
                                        />
                                        <div>
                                            <p className="text-lg font-bold leading-[133%] text-black-50 max-[576px]:text-[14px]">
                                                {item.fullName}
                                            </p>
                                            <p className="text-sm text-gray-600 leading-[114%] max-[576px]:text-[12px]">
                                                {item.date}
                                            </p>
                                        </div>
                                    </div>
                                    <GoogleIcon />
                                </div>
                                <div className="mt-4 max-[576px]:mt-[12px]">
                                    <StarRating  />
                                </div>
                                <p className="text-gray-900 text-lg leading-[120%] mt-6 max-[576px]:mt-[16px]  max-[576px]:text-[14px]">{item.text}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="flex justify-center space-x-3 min-[576px]:hidden mt-6">
                    <button
                        className="review-button-prev flex justify-center items-center w-[40px] h-[40px] px-2 rounded-full border-[2px] shadow-[0_8px_16px_0_#353C7880] border-violet-50 bg-white hover:bg-violet-50"
                        aria-label="Previous slide"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15.75 19.5L8.25 12l7.5-7.5"
                            />
                        </svg>
                    </button>
                    <button
                        className="review-button-next flex justify-center items-center w-[40px] h-[40px] px-2 rounded-full border-[2px] shadow-[0_8px_16px_0_#353C7880] border-violet-50 bg-white hover:bg-violet-50"
                        aria-label="Next slide"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth={1.5}
                            stroke="currentColor"
                            className="w-5 h-5"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M8.25 4.5l7.5 7.5-7.5 7.5"
                            />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default GoogleReviews;